import { useState, useEffect, useRef } from "react";
export default function ProductCategoriesRow2() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  const cards = [{
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/Front-Page_Welding-Machines.jpg",
    bannerColor: "#857830",
    lines: ["WELDING MACHINES"]
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/Front-Page_Boart-Longyear.jpg",
    bannerColor: "#2E7D32",
    lines: ["BOART LONGYEAR", "DRILL TOOLING & RIGS"]
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/Front-Page_Mastercool.jpg",
    bannerColor: "#2E7D32",
    lines: ["MASTERCOOL AIR CONDITIONING", "TOOLS & EQUIPMENT"]
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/Picture19.jpg",
    bannerColor: "#8B1A1A",
    lines: ["SWITCHBOARDS & ELECTRICAL", "COMPONENTS"]
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/Front-Page_VisionX.jpg",
    bannerColor: "#857830",
    lines: ["GLENCORE", "LIGHTING SOLUTIONS"]
  }];
  return;
}